/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  Modal,
  Typography,
} from "@mui/material";
import SelectSubject from "components/smea/Textfields/SelectSubject";
import SelectQuarter from "components/smea/Textfields/SelectQuarter";
import SelectComponent from "components/smea/Textfields/SelectComponents";
// import { useStateContext } from "contexts/ContextProvider";
import useAxiosPrivate from "contexts/interceptors/axios";
import SchoolYearDatePicker from "components/smea/Textfields/SchoolYearDatePicker";

import CancelIcon from "@mui/icons-material/Close";

// eslint-disable-next-line import/no-extraneous-dependencies
import "react-datepicker/dist/react-datepicker.css";
import SelectGradeLevel from "components/smea/Textfields/SelectGradeLevel";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  //   height: "80vh",
  width: "60vw",
  minWidth: "500px",
  transform: "translate(-50%, -50%)",
  bgcolor: "#f0f0f0",
  boxShadow: "3px 2px 20px 3px rgba(0, 0, 0, 0.3)",
  borderRadius: "10px",
  p: 4,
};

export default function FilterModal({
  open,
  handleClose,
  fetchCompetencies,
  onDetailsUpdate,
  competencyDetails,
  schoolDetails,
}) {
  // const { auth } = useStateContext();
  const axiosPrivate = useAxiosPrivate();

  const [subject, setSubject] = useState(competencyDetails.subjectId || "");
  const [component, setComponent] = useState(
    competencyDetails.componentId || ""
  );
  const [schoolYear, setSchoolYear] = useState();
  const [grade, setGrade] = useState(competencyDetails.gradeLevel || null);

  const [availableGradeLevels, setAvailableGradeLevels] = useState([]);

  const [quarter, setQuarter] = useState(competencyDetails.quarter || null);
  const [disable, setDisable] = useState(true);

  const [loading, setLoading] = useState("");
  const [error, setError] = useState("");

  const handleGenerateCompetencies = () => {
    if (component) {
      fetchCompetencies({
        subject,
        grade,
        quarter,
        component,
        schoolYear,
      });
    } else {
      fetchCompetencies({
        subject,
        grade,
        quarter,
        schoolYear,
      });
    }
  };

  useEffect(() => {
    if (schoolYear && quarter && subject) {
      setLoading(true);
      setError("");

      axiosPrivate
        .get(`/competency/fetchCompetencies`, {
          params: { schoolYear, quarter },
        })
        .then((e) => {
          const competencies = e?.data?.competencies;

          const competenciesBySubject = competencies.filter(
            (competency) => competency.subjectId === subject
          );

          const gradeLevelsAvailable = [];

          competenciesBySubject.forEach((competency) => {
            if (!gradeLevelsAvailable.includes(competency?.gradeLevel)) {
              gradeLevelsAvailable.push(competency?.gradeLevel);
            }
          });

          setAvailableGradeLevels(gradeLevelsAvailable);
        })
        .catch((err) => {
          // Handle network errors or any other errors here
          setError(err.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [schoolYear, quarter, subject, component]);

  useEffect(() => {
    onDetailsUpdate({
      schoolYear,
      subject,
      component,
      grade,
      quarter,
    });
  }, [schoolYear, subject, component, grade, quarter]);

  useEffect(() => {
    if (subject === 8) {
      setDisable(false);
    } else if (subject === 9) {
      setDisable(false);
    } else {
      setDisable(true);
    }
  }, [subject]);

  useEffect(() => {
    if (schoolDetails) {
      if (schoolDetails.officeTypeId === 1) {
        // console.log({ schoolDetails: schoolDetails.officeTypeId });
        setAvailableGradeLevels([1, 2, 3, 4, 5, 6]);
      } else if (schoolDetails.officeTypeId === 2) {
        setAvailableGradeLevels([7, 8, 9, 10]);
        // console.log({ schoolDetails: schoolDetails.officeTypeId });
      } else {
        setAvailableGradeLevels([1, 2, 3, 4, 5, 6, 7, 8, 9, 10]);
      }
    }
  }, []);

  useEffect(() => {
    if (open) {
      setGrade(competencyDetails.gradeLevel || "");
    }
  }, [open]);

  // console.log(availableGradeLevels);

  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason === "backdropClick") {
          return; // Ignore backdrop clicks
        }
        handleClose(); // Only allow closing through explicit actions
      }}
      disableEscapeKeyDown // Prevent closing with the Escape key
    >
      <Box sx={style}>
        <Box
          sx={{
            position: "absolute",
            right: 20,
            cursor: "pointer",
            zIndex: 100,
          }}
        >
          <IconButton onClick={handleClose} sx={{ p: 0 }}>
            <CancelIcon />
          </IconButton>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography sx={{ fontWeight: "bold" }}>
              NOTE: Fields marked with an asterisk (*) are required
            </Typography>
          </Grid>
          <Grid item xs={12} sx={{ zIndex: 1 }}>
            <Typography sx={{ color: "#2f2f2f" }}>School Year *</Typography>
            <SchoolYearDatePicker
              schoolYear={schoolYear}
              setSchoolYear={setSchoolYear}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography sx={{ color: "#2f2f2f" }}>Quarter *</Typography>
            <SelectQuarter
              placeholder="Select Quarter"
              // label="Grading Period"
              name="quarter"
              // disabled={loading}
              value={quarter}
              onChange={(fieldName, selectedValue) => {
                setQuarter(selectedValue);
              }}
              // disabled
              sx={{
                width: "100%",
                "&:hover": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "black !important",
                  },
                },
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <Typography sx={{ color: "#2f2f2f", mb: 1 }}>Subject *</Typography>
            <SelectSubject
              placeholder="Select a Subject"
              // label="Select a Subject"
              name="subject"
              // disabled={filteredCompetencies.length === 0 || loading}
              value={subject}
              onChange={(fieldName, selectedValue) => {
                setSubject(selectedValue);
                setComponent("");
              }}
              schoolDetails={schoolDetails}
              singleSelection
              sx={{
                width: "100%",
                "&:hover": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "black !important",
                  },
                },
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography sx={{ color: "#2f2f2f", mb: 1 }}>
              Component {subject === 8 || subject === 9 ? "*" : ""}
            </Typography>
            <SelectComponent
              placeholder="Select a Component"
              name="component"
              disabled={loading || disable}
              value={component}
              onChange={(fieldName, selectedValue) => {
                setComponent(selectedValue);
              }}
              subId={subject}
              gradeId={grade}
              sx={{
                width: "100%",
                "&:hover": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "black !important",
                  },
                },
              }}
            />
          </Grid>
          <Divider sx={{ mt: 4, width: "100%", backgroundColor: "gray" }} />
          <Grid item xs={12}>
            <Typography sx={{ color: "#2f2f2f", mb: 1 }}>Grade *</Typography>
            <SelectGradeLevel
              placeholder="Select a Grade Level"
              name="gradeLevel"
              disabled={availableGradeLevels.length === 0 || loading}
              value={grade}
              onChange={(fieldName, selectedValue) => {
                setGrade(selectedValue);
              }}
              availableGradeLevels={
                schoolDetails
                  ? schoolDetails.officeTypeId === 1
                    ? availableGradeLevels.filter(
                        (level) => level >= 1 && level <= 6
                      )
                    : schoolDetails.officeTypeId === 2
                    ? availableGradeLevels.filter(
                        (level) => level >= 7 && level <= 10
                      )
                    : schoolDetails.officeTypeId === 4
                    ? availableGradeLevels.filter(
                        (level) => level >= 1 && level <= 10
                      )
                    : availableGradeLevels
                  : availableGradeLevels
              }
              sx={{
                width: "100%",
                "&:hover": {
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "black !important",
                  },
                },
              }}
            />
          </Grid>
        </Grid>

        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 4,
          }}
        >
          <Button
            id="search"
            onClick={() => handleGenerateCompetencies()}
            variant="contained"
            disabled={
              !schoolYear ||
              !subject ||
              (!component && !disable) ||
              loading ||
              !grade ||
              !quarter
            }
            sx={{
              backgroundColor: "#2031C9",
              color: "#fff",
              fontSize: "15px",
              padding: "15px 5px",
              margintop: "15px",
              width: "120px",
              height: "40px",
              mr: 6,
              "&:hover": {
                backgroundColor: "#2F2F2F",
                fontWeight: "bolder",
              },
            }}
          >
            Encode
          </Button>
        </Box>
        {error}
      </Box>
    </Modal>
  );
}
